export default __webpack_public_path__ + "static/diving-e16dc5784ddb1bcb7f216ded7f6b793f.svg";